var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 9.33333C2.40917 9.33421 2.17418 9.18672 2.06303 8.95444C1.95188 8.72216 1.98444 8.44664 2.14667 8.24667L8.74667 1.44667C8.84863 1.32897 9.0185 1.29755 9.15582 1.371C9.29314 1.44445 9.3613 1.60319 9.32 1.75333L8.04 5.76667C7.96339 5.97172 7.99231 6.20131 8.11739 6.38095C8.24247 6.56059 8.44777 6.66738 8.66667 6.66667H13.3333C13.5908 6.66579 13.8258 6.81328 13.937 7.04556C14.0481 7.27784 14.0156 7.55336 13.8533 7.75333L7.25333 14.5533C7.15137 14.671 6.98149 14.7024 6.84418 14.629C6.70686 14.5556 6.6387 14.3968 6.68 14.2467L7.96 10.2333C8.03661 10.0283 8.00769 9.79869 7.88261 9.61905C7.75753 9.43941 7.55223 9.33262 7.33333 9.33333",
    stroke: "#D97706",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg9);
export default __webpack_public_path__ + "static/media/svg9.9b30386d76a35e3c8ea9834551dd854e.svg";
export { ForwardRef as ReactComponent };